module.exports = __webpack_public_path__ + "static/media/cheveron-down.d281834c.svg";